var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.9 8.402h1.8a.9.9 0 0 1 .9.9v10.8a.9.9 0 0 1-.9.9H5.3a.9.9 0 0 1-.9-.9v-10.8a.9.9 0 0 1 .9-.9h1.8v-.9a5.4 5.4 0 1 1 10.8 0zm-6.3 6.958v2.042h1.8V15.36a1.8 1.8 0 1 0-1.8 0m4.5-6.958v-.9a3.6 3.6 0 0 0-7.2 0v.9z"
  })));
};
export default SvgLock;